import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Row, Col, Image, Button } from "react-bootstrap";
import CityNameFilter from '../../components/common/cityNameFilter';
import {
    CategoryCauseGroup,
    TopCausesBannerSection,
    TopCitiesSection,
    BrowseStateGroup,
} from "../cities/citiesStyle"
import { CitiesBoxSubTitle } from '../../components/common/issueGrid/issueGridStyle';
import {
    Title,
    WriteReviewSection,
    ReviewText,
    ReviewRightSection,
    LeftQuote,
    RightQuote,
    RightBanner,
} from '../../components/common/commonSubBanner/commonSubBannerStyle';
import CategoryCauseBanner from "../../assests/images/category-cause-banner.webp"
import QuoteIcon from "../../assests/images/quoteicon.svg";
import { useNavigate, useParams } from 'react-router-dom';
import MetaComponent from "../../components/common/metaComponent";
import CharityList from "../../components/common/navigationComponents/charityList";
import { MajorCategories } from "./categoryData";
import { statesWithKeys } from "./stateData";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { allCategoriesHandler } from "../../redux/slices/allCauses/allCategories-slice";

const CategoryCause = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const { key } = useParams()
    const allCategories = useSelector((state: any) => state?.allCategories?.data?.results)
    useEffect(() => {
        if (key === "issues") {
            dispatch(allCategoriesHandler() as any)
        }
        return () => { }
    }, [key])

    return (
        <>
            <MetaComponent
                keywords=""
                description="Browse for nonprofits and charities by state. Find reviews, information and volunteer opportunities of local nonprofits organizations in your area."
                ogTitle="Browse Nonprofits and Charities by State"
                ogDescription="Browse for nonprofits and charities by state. Find reviews, information and volunteer opportunities of local nonprofits organizations in your area."
                ogUrl="https://qa.greatnonprofits.org/navigation/state"
                ogImage="https://cdn.greatnonprofits.org/img/dashboard/gnp_bug-orange.png"
            />
            <>
                <TopCausesBannerSection className='top-city-causes-banner'>
                    <WriteReviewSection>
                        <Container className="cont-w">
                            <Row>
                                <Col lg={6} sm={12} md={12}>
                                    <Title className='causes-title'>Find and share Experiences About a Nnprofit</Title>
                                    <ReviewText>If you have worked with a nonprofit, write a review and tell your story. </ReviewText>
                                    <Button className="write-yellow-btn" onClick={() => navigate("/write-review")}> Write a Review</Button>
                                </Col>
                                <Col lg={6} sm={12} md={12}>
                                    <RightBanner className="left_banner">
                                        <ReviewRightSection>
                                            <LeftQuote className="quote_col"><span><Image src={QuoteIcon} alt="QuoteIcon" /></span> I've worked in nonprofits for over 20 years, and having this tool now is a first for me. I'm really grateful for it.</LeftQuote>
                                            <Image src={CategoryCauseBanner} alt="ReviewImage" />
                                            <RightQuote className="quote_col"><span><Image src={QuoteIcon} alt="QuoteIcon" /></span> I've worked in nonprofits for over 20 years, and having this tool now is a first for me. I'm really grateful for it.</RightQuote>
                                        </ReviewRightSection>
                                    </RightBanner>
                                </Col>
                            </Row>
                        </Container>
                    </WriteReviewSection>
                </TopCausesBannerSection>

                <CategoryCauseGroup>
                    <Container className='cont-w'>
                        <Row>
                            <Col sm="12">
                                <CityNameFilter />
                            </Col>
                        </Row>
                    </Container>
                </CategoryCauseGroup>

                <TopCitiesSection>
                    {key === "issues" && <Container className='cont-w'>

                        <CitiesBoxSubTitle>Major Categories</CitiesBoxSubTitle>

                        <CharityList charities={MajorCategories} />

                        <CitiesBoxSubTitle>All Categories</CitiesBoxSubTitle>
                        <CharityList charities={allCategories?.map((item: any) => ({ ...item, href: "/categories/view/" + item.slug }))} />

                    </Container>}
                    {key === "state" && <Container className='cont-w'>
                        <CharityList charities={statesWithKeys} />
                    </Container>}
                </TopCitiesSection>

                {key !== "state" && <BrowseStateGroup>
                    <Container className='cont-w'>
                        <Row>
                            <Col sm="12"><CityNameFilter showTitleBox={false} /></Col>
                        </Row>
                    </Container>
                </BrowseStateGroup>}
            </>
        </>

    );
}

export default CategoryCause;
